export enum VOTES {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546515485
     */
    DOWNVOTE = 'POST_DOWNVOTE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533530362
     */
    PLURALIZED_DOWNVOTES = 'POST_PLURALIZED_DOWNVOTES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546515519
     */
    UPVOTE = 'POST_UPVOTE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533529991
     */
    PLURALIZED_UPVOTES = 'POST_PLURALIZED_UPVOTES',
}
